/**
 * Build-time constants for the admin dashboard.
 *
 * ``VITE_API_BASE_URL`` is the only env var the SPA needs. Set in
 * Cloudflare Pages → admin-dashboard project → Settings → Environment
 * variables. Default points at the production backend so the SPA
 * works without env config in case of misconfig — better to talk to
 * prod than to be silently broken.
 */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL || "https://lenavio.onrender.com/api/v1";

/** Where to send users who fail the is_internal gate. */
export const CUSTOMER_APP_URL: string =
  import.meta.env.VITE_CUSTOMER_APP_URL || "https://app.lenavio.com";
